import { PAYMENT_STATUS } from "@elixir/types";
import { ReactComponent as CircleCheckIcon } from "../../assets/icons/font-awesome/circle-check.svg";
import { ReactComponent as CircleExclamationSolidIcon } from "../../assets/icons/font-awesome/circle-exclamation-solid.svg";
import { ReactComponent as RupeeSolidIcon } from "../../assets/icons/font-awesome/rupee-solid.svg";
import { ReactComponent as XMarkSolidIcon } from "../../assets/icons/font-awesome/xmark-solid.svg";
import { getPaymentStatusMapping } from "@elixir/utils";

export default function PaymentStatusChip({
  status,
}: {
  status: PAYMENT_STATUS;
}): JSX.Element {
  const skeletonClass =
    "inline-flex items-center px-8 py-4 space-x-6 text-12 rounded-4";

  const textMainClass = "text-12 font-400 leading-6";

  switch (status) {
    case PAYMENT_STATUS.UNBILLED:
      return (
        <div className={`${skeletonClass} bg-darwin-neutral-100`}>
          <div className="flex items-center justify-center w-16 h-16">
            <CircleExclamationSolidIcon className="w-16 h-16 text-darwin-neutral-700" />
          </div>
          <p className={`${textMainClass} text-darwin-neutral-700`}>
            {getPaymentStatusMapping(status)}
          </p>
        </div>
      );
    case PAYMENT_STATUS.SUCCESS:
      return (
        <div className={`${skeletonClass} bg-darwin-accent-green-200`}>
          <div className="flex items-center justify-center w-16 h-16">
            <CircleCheckIcon className="w-16 h-16 text-darwin-accent-green-900" />
          </div>
          <p className={`${textMainClass} text-darwin-accent-green-900`}>
            {getPaymentStatusMapping(status)}
          </p>
        </div>
      );
    case PAYMENT_STATUS.TO_REFUND:
      return (
        <div className={`${skeletonClass} bg-darwin-accent-bright-yellow-200`}>
          <div className="flex items-center justify-center w-16 h-16">
            <RupeeSolidIcon className="w-16 h-16 text-darwin-accent-bright-yellow-900" />
          </div>
          <p
            className={`${textMainClass} text-darwin-accent-bright-yellow-900`}
          >
            {getPaymentStatusMapping(status)}
          </p>
        </div>
      );
    case PAYMENT_STATUS.REFUNDED:
    case PAYMENT_STATUS.REFUND_PROCESSED:
      return (
        <div className={`${skeletonClass} bg-darwin-accent-symptoms-blue-200`}>
          <div className="flex items-center justify-center w-16 h-16">
            <CircleCheckIcon className="w-16 h-16 text-darwin-accent-dark-blue-500" />
          </div>
          <p className={`${textMainClass} text-darwin-accent-dark-blue-500`}>
            {getPaymentStatusMapping(status)}
          </p>
        </div>
      );
    case PAYMENT_STATUS.CREATED:
      return (
        <div className={`${skeletonClass} bg-darwin-accent-bright-yellow-200`}>
          <div className="flex items-center justify-center w-16 h-16">
            <RupeeSolidIcon className="w-16 h-16 text-darwin-accent-bright-yellow-900" />
          </div>
          <p
            className={`${textMainClass} text-darwin-accent-bright-yellow-900`}
          >
            {getPaymentStatusMapping(status)}
          </p>
        </div>
      );
    case PAYMENT_STATUS.CANCELLED:
      return (
        <div className={`${skeletonClass} bg-darwin-status-warning-100`}>
          <div className="flex items-center justify-center w-16 h-16">
            <XMarkSolidIcon className="w-16 h-16 text-darwin-status-warning-500" />
          </div>
          <p className={`${textMainClass} text-darwin-status-warning-500`}>
            {getPaymentStatusMapping(status)}
          </p>
        </div>
      );
    case PAYMENT_STATUS.FAILED:
      return (
        <div className={`${skeletonClass} bg-darwin-status-warning-100`}>
          <div className="flex items-center justify-center w-16 h-16">
            <CircleExclamationSolidIcon className="w-16 h-16 text-darwin-status-warning-100" />
          </div>
          <p className={`${textMainClass} text-darwin-status-warning-100`}>
            {getPaymentStatusMapping(status)}
          </p>
        </div>
      );
    default:
      return <>-</>;
  }
}
